import { render, staticRenderFns } from "./LocaleBtn.vue?vue&type=template&id=7bf867ff&scoped=true&"
import script from "./LocaleBtn.vue?vue&type=script&lang=js&"
export * from "./LocaleBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf867ff",
  null
  
)

export default component.exports